
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/building-4","xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.967 37.933a1.25 1.25 0 01-1.25-1.25V29.25a1.25 1.25 0 011.25-1.25 1.25 1.25 0 011.25 1.25v7.433a1.25 1.25 0 01-1.25 1.25z","fill":"#090A0A"}}),_c('path',{attrs:{"data-name":"Vector","d":"M17.917 15h-8.25a1.25 1.25 0 01-1.25-1.25 1.25 1.25 0 011.25-1.25h8.25a1.25 1.25 0 011.25 1.25 1.25 1.25 0 01-1.25 1.25zM17.917 21.25h-8.25A1.25 1.25 0 018.417 20a1.25 1.25 0 011.25-1.25h8.25a1.25 1.25 0 011.25 1.25 1.25 1.25 0 01-1.25 1.25zM13.75 37.917a1.25 1.25 0 01-1.25-1.25v-6.25a1.25 1.25 0 011.25-1.25 1.25 1.25 0 011.25 1.25v6.25a1.25 1.25 0 01-1.25 1.25z","fill":"#090A0A"}}),_c('path',{attrs:{"data-name":"Vector","d":"M38.334 37.917H1.667a1.25 1.25 0 01-1.25-1.25 1.25 1.25 0 011.25-1.25h36.667a1.25 1.25 0 011.25 1.25 1.25 1.25 0 01-1.25 1.25zM33 16.9a4.906 4.906 0 014.916 4.917V25.6a4.906 4.906 0 01-4.917 4.917 4.906 4.906 0 01-4.916-4.917v-3.783A4.906 4.906 0 0133 16.9zm0 11.117a2.419 2.419 0 002.416-2.417v-3.783a2.417 2.417 0 00-4.833 0V25.6A2.419 2.419 0 0033 28.017z","fill":"#F5CF37"}}),_c('path',{attrs:{"data-name":"Vector","d":"M23.833 37.917a1.25 1.25 0 01-1.25-1.25V10.05a4.032 4.032 0 00-.88-2.9 3.874 3.874 0 00-2.837-.888H8.483C5.867 6.267 4.75 7.398 4.75 10.05v26.617a1.25 1.25 0 01-1.25 1.25 1.25 1.25 0 01-1.25-1.25V10.05a6.361 6.361 0 011.61-4.652 6.247 6.247 0 014.623-1.631h10.384c4.009 0 6.217 2.231 6.217 6.283v26.617a1.25 1.25 0 01-1.251 1.25z","fill":"#F5CF37"}})])
          )
        }
      }
    